import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';
import { ConfirmarEliminacion } from './ConfirmarEliminacion';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [

{
    path      : 'Resolucion',
    component: ConfirmarEliminacion,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Resolucion',
          nombreFormulario : 'Consultar Resolucion'
        } 
}
];

@NgModule({
    declarations: [
        ConfirmarEliminacion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports  : [
        ConfirmarEliminacion
    ]
})


export class ConfirmarEliminacionModule{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Dialog/ConfirmarEliminacion.module.ts